import axios from "axios";
import { resolveApiUrl } from "lib/env";

const instance = axios.create({
  baseURL: resolveApiUrl(),
  timeout: 15000,
});

instance.defaults.withCredentials = true;

export default instance;
